'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _handleActions;

var _fluxActions = require('flux-actions');

var _ActionTypes = require('MeetingsLib/redux/actions/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _FormState = require('MeetingsLib/models/FormState');

var _FormState2 = _interopRequireDefault(_FormState);

var _pick = require('transmute/pick');

var _pick2 = _interopRequireDefault(_pick);

var _keySeq = require('transmute/keySeq');

var _keySeq2 = _interopRequireDefault(_keySeq);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = new _FormState2.default();

exports.default = (0, _fluxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _ActionTypes2.default.PUBLIC_AVAILABILITY_INFO_FETCH_SUCCEEDED, function (state, action) {
  var configuredCustomFormFields = action.payload.customFormFields;

  var validFields = (0, _pick2.default)((0, _keySeq2.default)(configuredCustomFormFields), state.customFormFields);
  return state.set('customFormFields', configuredCustomFormFields.merge(validFields));
}), _defineProperty(_handleActions, _ActionTypes2.default.SET_FORM_FIELD, function (state, action) {
  var _action$payload = action.payload,
      fieldName = _action$payload.fieldName,
      fieldValue = _action$payload.fieldValue;


  if (state.has(fieldName)) {
    return state.set(fieldName, fieldValue);
  } else if (state.hasIn(['customFormFields', fieldName])) {
    return state.setIn(['customFormFields', fieldName], fieldValue);
  }

  return state;
}), _handleActions), initialState);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/redux/reducers/stagedFormState.js
// module id = 523
// module chunks = 0